import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'w-dropdown-field',
  templateUrl: './dropdown-field.component.html',
  styleUrls: ['./dropdown-field.component.scss']
})
export class DropdownFieldComponent implements OnInit, OnChanges {
  @Input() value: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() options: any[];
  @Input() optionLabel: string;
  @Input() label: string;
  @Input() hideLabel: boolean = false;

  index: number;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.value && changes.value.currentValue) {
      this.value = changes.value.currentValue;
      this.findIndex();
    }
  }

  private findIndex() {
    let i = 0;
    for (const val of this.options) {
      if (val === this.value) {
        this.index = i;
        break;
      }
      i++;
    }
  }
}
